export class HttpError {
    constructor(public isReadable: boolean, public message: string, public status: number) {

    }
}